import React, {useEffect, useState} from 'react';
import ContractModel from '../models/contract';
import './scss/contract-view.scss';
import CollectionImageSmall from './collection-image-small';
import ProcessModel from '../models/process';
import ProcessAddContract from './process-add-contract';
import ProcessInfoContract from './process-info-contract';
import ProcessContractModel from '../models/process-contract';
import EventsModel from '../models/event';
import Event from './event';
import StatusProp from './properties/status';
import Loader from './loader';
import EmptyView from './empty-view';
import Error from './error';
import Web3Nova from '../services/web3Nova';
import SandraJsAPI from "../services/sandraJsAPI";

function ContractView({setStatusMessage}: StatusProp): React.ReactElement {
    const urlParams = new URLSearchParams(window.location.search);
    const contractHash = String(urlParams.get('hash'));
    const contractInit: ContractModel = {
        collections: [],
        address: '',
        blockchain: '',
        standard: '',
        token: {
            tokenId: '',
            tokenUrl: ''
        },
        assetKeyId: '',
        baseTokenUrl: '',
        metadataType: '',
    };

    const eventsInit: EventsModel[] = [];
    const processInit: ProcessModel = {
        id: "",
        processDescription: "",
        appName: "",
        monitor: {
            cpu: 0,
            memory: 0
        },
        blockchain: "",
        processTitle: "",
        processID: "",
        lastStartTime: "",
        status: "",
        lastStopTime: "",
        addresses: []
    };
    const processContractInit: ProcessContractModel = {
        endBlock: "",
        blockRange: "",
        hash: "",
        status: "",
        startBlock: "",
        metadataType: "",
        lastUpdateTime: "",
        lastBlockProcessed: "",
        standard: "",
        collections: [],
        lastBlockSaved: ""
    };
    const [events, setEvents] = useState(eventsInit);

    const [process, setProcess] = useState(processInit);
    const [contract, setContract] = useState(contractInit);
    const [processContract, setProcessContract] = useState(processContractInit);

    const [isLoading, setIsLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [latestBlockNumber, setLatestBlockNumber] = useState(0);

    function getLatestBlockNumber(chain: string) {
        const web3 = new Web3Nova(chain);
        web3.getLatestBlockNumber().then(
            (blockNumber) => {
                setLatestBlockNumber(blockNumber);
            },
        ).catch((reason) => {
            console.log(reason.message);
        });
    }

    useEffect(() => {
        setIsLoading(true);
        SandraJsAPI.getContractAsync((contractHash))
            .then((result) => {
                if (result.error) {
                    setErrorMessage(result.error.message);
                } else {
                    setContract(result.data);
                    setProcess(result.data.process);
                    setProcessContract(result.data.scan);
                    setEvents(result.data.events);
                    getLatestBlockNumber(result.data.blockchain);
                }
                setIsLoading(false);
            })
            .catch((reason) => {
                setIsLoading(false);
                setErrorMessage(reason.message);
            });
    }, []);

    let pageView: JSX.Element;

    const contractView = (
        <div>
            <span className="text-sm-light text-uppercase">{contract?.standard}</span>
            <span className="vr"/>
            <span className="text-sm-light text-uppercase">{contract?.blockchain}</span>
            <span className="vr"/>
            <span className="text-sm-light text-uppercase">{contract?.metadataType}</span>
            <div className="text-sm-light pt-1 fst-italic" style={{fontSize: '12px'}}>
                Latest block on
                <span className="p-1">{contract?.blockchain}</span>
                {latestBlockNumber}
            </div>
            <div className="row pt-3">
                <h6 className="pt-1 pb-3">Belongs to collection</h6>
                {
                    contract?.collections?.map(
                        (collection) => (
                            <CollectionImageSmall
                                key={collection.imageUrl}
                                collection={collection}
                            />
                        ),
                    )
                }
            </div>
            <div className="row pb-2">
                <h6 className="">Running on process</h6>
                <div className="ps-3">
                    <a className="text-sm-label"
                       href={`/jetski/process/?id=${process?.id}`}>
                        {process?.id || "None"}
                    </a>
                    <p className="fst-italic p-2" style={{fontSize: '14px'}}>
                        {process?.processDescription}
                    </p>
                </div>
            </div>
        </div>
    );

    const processView = ((process)
        ? (
            <ProcessInfoContract
                processContract={processContract}
                setStatusMessage={setStatusMessage}
            />
        )
        : (
            <ProcessAddContract
                standard={contract.standard}
                hash={contract.address}
                blockchain={contract.blockchain}
                metadataType={contract.metadataType}
                setStatusMessage={setStatusMessage}
            />
        ));

    if (errorMessage) {
        pageView = <Error header="Oops! Server says" description={errorMessage}/>;
    } else if (contract && contract.address) {
        pageView = (
            <div className="row ps-4 contract-view">
                <div className="col-sm-6">
                    <h5 className="pb-3">Contract Address</h5>
                    <h6>{contractHash}</h6>
                    {contractView}
                </div>
                <div className="col-sm-6">
                    <Event events={events}/>
                </div>
                <div className="row ">
                    <div className="col">
                        {processView}
                    </div>
                </div>
            </div>
        );
    } else {
        pageView = (
            <div className="row ps-4 contract-view">
                <div className="col">
                    <h5 className="pb-3">Contract Address</h5>
                    <h6>{contractHash}</h6>
                    <EmptyView title="Contract details not found" desc=""/>
                </div>
            </div>
        );
    }

    return (
        <div>
            {
                isLoading
                    ? (
                        <div style={{padding: '5rem', textAlign: 'center'}}>
                            <Loader width="70px" imageNumber="0"/>
                        </div>
                    )
                    : pageView
            }
        </div>
    );
}

export default ContractView;
